





















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface DateRangeModel {
  dateStart: Date;
  dateEnd: Date;
}

@Component({})
export default class SearchDateRange extends Vue {
  @Prop() datesModel: DateRangeModel;

  @Prop() sectionLabel?: string;

  startDatePickerOptions = {
    disabledDate: (date: Date) => {
      if (!this.datesModel) return false;
      return date > this.datesModel.dateEnd;
    },
    firstDayOfWeek: 1
  };

  endDatePickerOptions = {
    disabledDate: (date: Date) => {
      if (!this.datesModel) return false;
      return date < this.datesModel.dateStart;
    },
    firstDayOfWeek: 1
  };

  onDateChange(name: "dateStart" | "dateEnd", value: Date) {
    const updatedDate = { ...this.datesModel };
    updatedDate[name] = value;
    this.$emit("onDatesUpdate", this.formatDateTime(updatedDate));
  }

  formatDateTime(dateModel: DateRangeModel) {
    const updatedModel = { ...dateModel };
    if (dateModel.dateStart) {
      updatedModel.dateStart.setHours(0, 0, 0);
    } else if (dateModel.dateEnd) {
      updatedModel.dateEnd.setHours(23, 59, 59);
    }
    return updatedModel;
  }
}
